<template>
    <div class="emailSettingAccountNotSynced">
        <div class="emailSettingAccountNotSynced__content-wrapper">
            <div>
                <img src="/ressources/logged/img/illustrations/no-email-connected.svg" />
            </div>
            <div class="emailSettingAccountNotSynced__content">
                <h3 class="emailSettingAccountNotSynced__title">
                    {{ $t.__('email.EmailSettingAccountNotSynced.title') }}
                </h3>
                <p class="emailSettingAccountNotSynced__subtitle">
                    {{ $t.__('email.EmailSettingAccountNotSynced.subtitle') }}
                </p>
            </div>
        </div>
        <div>
            <router-link v-if="isAdmin || !isEmailsSentFromCorp" :to="{ name: 'onboarding.email' }">
                <CompassButton :label="$t.__('email.configure_email_service')" />
            </router-link>
        </div>
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useStore } from 'vuex';

defineProps<{ isEmailsSentFromCorp: boolean }>();

const store = useStore();
const isAdmin = computed(() => store.state.user.isAdmin);
</script>
<style lang="scss" scoped>
.emailSettingAccountNotSynced {
    border-radius: 4px;
    background: var(--colors-common-background-subtle);
    padding: var(--spacing-3);
    display: flex;
    align-items: center;
    justify-content: space-between;

    &__content {
        margin-left: var(--spacing-3);
    }

    &__content-wrapper {
        display: flex;
        align-items: center;
        max-width: 80%;
    }

    &__title {
        margin: 0;
        line-height: var(--line-heights-24);
    }

    &__subtitle {
        margin-top: var(--spacing-1);
        margin-bottom: 0;
        color: var(--colors-common-text-subtle-default);
        font-size: var(--font-size-14);
        line-height: var(--line-heights-20);
    }
}
</style>
